export default __webpack_public_path__ + "static/media/redeem-right.bcd2f473.svg";